import React, { useCallback } from 'react';

import { getPopperProps } from '../../utils/menus';
import { EmojiPopoverProps } from './types';
import { useMenuItemClick } from './useEmojiPopover';
import { closeDialog } from './utils';

const POPOVER_MAX_HEIGHT = 20;

function EmojiPopover(props: EmojiPopoverProps) {
  const { open, ListComponent, editorView, match } = props;

  const onItemClick = useMenuItemClick(editorView, match);
  const onDialogClose = useCallback(() => {
    closeDialog(editorView.state, editorView.dispatch);
    editorView.focus();
  }, [editorView]);

  if (!open || !editorView) {
    return null;
  }

  return (
    <ListComponent
      popperProps={getPopperProps({ editorView, maxHeight: POPOVER_MAX_HEIGHT })}
      searchString={match}
      onClick={onItemClick}
      onClose={onDialogClose}
    />
  );
}

export default EmojiPopover;
